import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaBook,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const ELearningTrainingVideoProductionInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="E-learning and Training Video Production in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Empower Your Audience</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">
              E-learning & Training Video Production
            </span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our e-learning and training video production
            services in **Al Barsha** create engaging, high-quality videos that
            educate and inspire. From corporate training modules to online
            courses, we deliver clear, visually appealing content designed to
            enhance learning and retention.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1610484826967-09c5720778c7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1623039405147-547794f92e9e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert E-learning & Training Video Production in Al Barsha"
        description="We create educational videos that engage and inform effectively."
        cards={[
          {
            icon: <FaBook color="#ff5464" size={40} />,
            title: "Engaging Content",
            description:
              "Interactive and clear videos that enhance learning outcomes.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "High-Quality Visuals",
            description: "Professional visuals to maintain viewer focus.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Timely production to meet your training deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Platform-Optimized",
            description:
              "Videos tailored for LMS, mobile, or online platforms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Al Barsha’s choice for e-learning video production.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "End-to-End Service",
            description: "From scripting to final edit, we handle it all.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our E-learning & Training Video Production Process"
        description={
          <Description>
            We create effective educational videos through a streamlined,
            creative process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Understand your training goals and audience needs.
              </li>
              <li>Scripting: Develop clear, concise scripts or storyboards.</li>
              <li>
                Design: Create visuals, animations, or live-action footage as
                needed.
              </li>
              <li>
                Filming/Animation: Produce high-quality content with
                professional tools.
              </li>
              <li>
                Post-Production: Add voiceovers, captions, and interactive
                elements.
              </li>
              <li>
                Delivery: Provide polished videos ready for your learning
                platform.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1610821678660-aa33854d5a36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1587614382346-4ec70e388b28?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="E-learning & Training Video Wins in Al Barsha"
        description="Our videos have transformed training and education programs."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Corporate Training",
            description: "Produced a series that improved employee onboarding.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Online Course",
            description:
              "Created engaging modules for a popular e-learning platform.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from e-learning video clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Educate Effectively?</Subheading>}
        heading="E-learning & Training Video Production in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional e-learning and training
            video production in Al Barsha. Create engaging, high-quality videos
            that enhance learning and drive results—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1581078427855-1337af4a50c1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
          "https://images.unsplash.com/photo-1538092547879-34b0b5fe9841?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
